/** Horizontal slide (forward / back along the stack). */
export const SLIDE_DURATION_MS = 350;

/** `usePageTransition` fallback if transition events never fire — must exceed the longest CSS slide. */
export const TRANSITION_COMPLETE_TIMEOUT_MS = SLIDE_DURATION_MS + 100;
